// Mock sales data for admin dashboard
export const mockSalesData = {
  // Daily sales for the last 30 days
  dailySales: [
    { date: '2025-06-25', revenue: 234, orders: 3 },
    { date: '2025-06-26', revenue: 456, orders: 6 },
    { date: '2025-06-27', revenue: 378, orders: 5 },
    { date: '2025-06-28', revenue: 512, orders: 7 },
    { date: '2025-06-29', revenue: 289, orders: 4 },
    { date: '2025-06-30', revenue: 645, orders: 9 },
    { date: '2025-07-01', revenue: 423, orders: 6 },
    { date: '2025-07-02', revenue: 556, orders: 8 },
    { date: '2025-07-03', revenue: 389, orders: 5 },
    { date: '2025-07-04', revenue: 712, orders: 10 },
    { date: '2025-07-05', revenue: 534, orders: 7 },
    { date: '2025-07-06', revenue: 467, orders: 6 },
    { date: '2025-07-07', revenue: 623, orders: 9 },
    { date: '2025-07-08', revenue: 445, orders: 6 },
    { date: '2025-07-09', revenue: 578, orders: 8 },
    { date: '2025-07-10', revenue: 689, orders: 10 },
    { date: '2025-07-11', revenue: 523, orders: 7 },
    { date: '2025-07-12', revenue: 756, orders: 11 },
    { date: '2025-07-13', revenue: 634, orders: 9 },
    { date: '2025-07-14', revenue: 812, orders: 12 },
    { date: '2025-07-15', revenue: 567, orders: 8 },
    { date: '2025-07-16', revenue: 923, orders: 13 },
    { date: '2025-07-17', revenue: 678, orders: 10 },
    { date: '2025-07-18', revenue: 845, orders: 12 },
    { date: '2025-07-19', revenue: 734, orders: 11 },
    { date: '2025-07-20', revenue: 956, orders: 14 },
    { date: '2025-07-21', revenue: 867, orders: 12 },
    { date: '2025-07-22', revenue: 1023, orders: 15 },
    { date: '2025-07-23', revenue: 789, orders: 11 },
    { date: '2025-07-24', revenue: 934, orders: 13 },
  ],

  // Monthly sales for the last 12 months
  monthlySales: [
    { month: 'Aug 2024', revenue: 8450, orders: 124 },
    { month: 'Sep 2024', revenue: 9230, orders: 138 },
    { month: 'Oct 2024', revenue: 10120, orders: 152 },
    { month: 'Nov 2024', revenue: 14560, orders: 218 },
    { month: 'Dec 2024', revenue: 18920, orders: 284 },
    { month: 'Jan 2025', revenue: 12340, orders: 185 },
    { month: 'Feb 2025', revenue: 11890, orders: 178 },
    { month: 'Mar 2025', revenue: 13450, orders: 201 },
    { month: 'Apr 2025', revenue: 14780, orders: 221 },
    { month: 'May 2025', revenue: 16230, orders: 243 },
    { month: 'Jun 2025', revenue: 17890, orders: 268 },
    { month: 'Jul 2025', revenue: 19450, orders: 291 },
  ],

  // Product breakdown
  productSales: [
    { name: 'Timeless Remedy 2oz', value: 45, revenue: 3060 },
    { name: 'Timeless Remedy 5oz', value: 55, revenue: 7040 },
  ],

  // Recent orders
  recentOrders: [
    { id: 'ER-00001234', date: '2025-07-24', customer: 'Sarah Johnson', items: 'Timeless Remedy 2oz', total: 68.00, status: 'Delivered' },
    { id: 'ER-00001233', date: '2025-07-24', customer: 'Michael Chen', items: 'Timeless Remedy 5oz', total: 128.00, status: 'Shipped' },
    { id: 'ER-00001232', date: '2025-07-24', customer: 'Emily Davis', items: 'Timeless Remedy 2oz (x2)', total: 136.00, status: 'Processing' },
    { id: 'ER-00001231', date: '2025-07-23', customer: 'James Wilson', items: 'Timeless Remedy 5oz', total: 128.00, status: 'Delivered' },
    { id: 'ER-00001230', date: '2025-07-23', customer: 'Lisa Anderson', items: 'Timeless Remedy 2oz', total: 68.00, status: 'Delivered' },
    { id: 'ER-00001229', date: '2025-07-23', customer: 'Robert Brown', items: 'Timeless Remedy 5oz, Timeless Remedy 2oz', total: 196.00, status: 'Delivered' },
    { id: 'ER-00001228', date: '2025-07-22', customer: 'Amanda Miller', items: 'Timeless Remedy 2oz', total: 68.00, status: 'Delivered' },
    { id: 'ER-00001227', date: '2025-07-22', customer: 'David Taylor', items: 'Timeless Remedy 5oz (x2)', total: 256.00, status: 'Delivered' },
  ],

  // Summary stats
  summary: {
    totalRevenue: 157310,
    totalOrders: 2503,
    averageOrderValue: 62.85,
    conversionRate: 3.2,
    returningCustomers: 34,
    thisMonthRevenue: 19450,
    thisMonthOrders: 291,
    revenueGrowth: 8.7,
    ordersGrowth: 8.6,
  }
};
